export const DAILY_RENT_OTA_CONVERSION = 'dailyrent_web_sut375_online_booking_cr';

export const EXPERIMENTS = [DAILY_RENT_OTA_CONVERSION];
